import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-accent text-accent-foreground">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <p className="font-display text-5xl sm:text-6xl tracking-mega leading-[0.9]">
            FaeVor Works
          </p>
          <p className="mt-5 text-xl text-accent-foreground/70 max-w-sm">
            There's FaeVor in Your Future.
          </p>
          <p className="mt-2 text-sm uppercase tracking-[0.2em] text-primary font-semibold">
            Real Estate Solutions
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-accent-foreground/50 mb-4">
            Explore
          </p>
          <ul className="space-y-3 text-lg">
            <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
            <li><Link to="/real-estate" className="hover:text-primary transition-colors">Real Estate Solutions</Link></li>
            <li><Link to="/about" className="hover:text-primary transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-accent-foreground/50 mb-4">
            Reach Us
          </p>
          <ul className="space-y-3 text-lg">
            <li><a href="tel:+19732826924" className="hover:text-primary transition-colors">(973) 282-6924</a></li>
            <li><a href="mailto:faevorworks@gmail.com" className="hover:text-primary transition-colors">faevorworks@gmail.com</a></li>
            <li className="text-accent-foreground/60">Mon–Fri · 9am–6pm</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-accent-foreground/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-accent-foreground/60">
        <span>© 2026 FaeVor Works. All Rights Reserved.</span>
        <span className="uppercase tracking-[0.2em]">Don't Miss Out on Your FaeVor!</span>
      </div>
    </div>
  </footer>
);
